export const UserData = {
    data() {
        return {}
    },
    methods: {
        // 部门列表
        GetDepartmentData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/department',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 身份列表
        GetIdentityData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/identity',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // 员工列表
        GetUserData(obj) {
            return new Promise((resolve, reject) => {
                this.$request({
                    url: '/api/v1/users',
                    params:
                        obj && obj.data
                            ? {
                                  ...obj.data
                              }
                            : null
                })
                    .then(res => {
                        if (!res.status) {
                            resolve(res.data)
                        } else {
                            this.$message.error(res.message || '操作失败')
                        }
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        }
    }
}
